import React, { useEffect, Suspense, useReducer, useRef } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import cookie from 'react-cookies'
import templateServices from '../../services/TemplateServices'
import { get, isNil, isEmpty } from "lodash"
import { translate } from 'react-i18next';
import AccountAction from '../../actions/AccountAction'
import { EVENT } from '../../events/listEvents'
import Constants from '../../common/Constants'
import CommonUtil from '../../common/CommonUtil'
import CommonActions from '../../actions/CommonActions';
import { LayoutTemplateSlice } from '../../slices/LayoutTemplateSlice';
import { AccountsSlice } from '../../slices/AccountsSlice';
import { AlertSlice,closeAlert } from '../../slices/AlertSlice';
import { isHomePageSelector, isChangePasswordPageSelector } from '../../slices/LayoutTemplateSlice';
import { matchPath } from 'react-router-dom';

const WindowPopupComponent = CommonActions.lazyWithPreload(() => import( '../CompactView/WindowPopupComponent'));
const TermsConditionsComponent = CommonActions.lazyWithPreload(() => import("../TermsConditionsComponent"));
//ToDo
// const SurveyComponent = CommonActions.lazyWithPreload(() => import( "../SurveyComponent"));
const LiveScoreNotifyContentComponent = CommonActions.lazyWithPreload(() => import("../../components/CompactView/LiveScoreNotifyContentComponent"));
const LiveScoreNotifySettingupComponent = CommonActions.lazyWithPreload(() => import("../../components/CompactView/LiveScoreNotifySettingupComponent"));


const HeaderComponent = (props) => {
  let dataComps = []
  let intervalTime
  const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
  const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
  const isHomePage = useSelector(isHomePageSelector);
  const isChangePasswordPage = useSelector(isChangePasswordPageSelector);
  const user = useSelector(state => state.AccountsSlice.user);
  const fixed = useSelector(state => state.LayoutTemplateSlice.fixed);
  const nonLoginCurrency = useSelector(state => state.BetslipSlice.nonLoginCurrency);
  const enableCompactViewNotify = useSelector(state => get(state.LayoutTemplateSlice, 'templateData.attributes.enableCompactViewNotify'), shallowEqual);
  const dispatch = useDispatch();
  const ref = useRef({
      innerWidth: 0,
      _fixed: ''
  });
  const isPA = CommonUtil.isPA();

  const noneHeader = templateData.isNonNeader || false
  if (templateData.headerContainer != null) {
    dataComps = templateData.headerContainer.formal || []
  }
  const headerComponent = templateServices.listComponentsByData(dataComps, user.auth, props.router) || null
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      firstLogin: false,
    }
  )
  useEffect(() => {
    if (
      props.fixedWhenScroll != null && 
      props.fixedWhenScroll === true &&
      matchPath(get(props.router, 'router.location.pathname', ''), {
        path: `/:lang${window.env.leaderBoardPathName}`,
        exact: true
      }) === null
    ) {
      window.listenEvent('scroll', handleScroll)
    }
    resize();
    checkDataNoCache()
    intervalTime = user.auth ? setInterval(setAccount, 10 * 1000) : null;
    window.listenEvent(EVENT.DATA_NOCACHE_AUTH, checkDataNoCache)
    window.listenEvent(EVENT.ACCOUNT_BALANCE_RELOAD, reloadAccountBalance)
    window.listenEvent(EVENT.CLOSE_COMPACT_VIEW_NOTIFY, closeCompactViewNotify)
    window.listenEvent(EVENT.OPEN_NEW_BETSLIP_MOBILE_NOTIFY, openNewBetslipMobileNotify)
    window.listenEvent(EVENT.CLOSE_NEW_BETSLIP_MOBILE_NOTIFY, closeNewBetslipMobileNotify)
    window.addEventListener("resize", resize);
    window.listenEvent(EVENT.MULTIPLE_LOGIN, AccountAction.handleMutipleLogin);
    return function cleanup() {
      // componentWillUnmount
      window.stopListenEvent('scroll', handleScroll)
      window.stopListenEvent('resize', resize);
      window.stopListenEvent(EVENT.DATA_NOCACHE_AUTH, checkDataNoCache)
      window.stopListenEvent(EVENT.ACCOUNT_BALANCE_RELOAD, reloadAccountBalance)
      window.stopListenEvent(EVENT.CLOSE_COMPACT_VIEW_NOTIFY, closeCompactViewNotify)
      window.stopListenEvent(EVENT.OPEN_NEW_BETSLIP_MOBILE_NOTIFY, openNewBetslipMobileNotify)
      window.stopListenEvent(EVENT.CLOSE_NEW_BETSLIP_MOBILE_NOTIFY, closeNewBetslipMobileNotify)
      window.stopListenEvent(EVENT.MULTIPLE_LOGIN, AccountAction.handleMutipleLogin);
      if (intervalTime) {
        clearInterval(intervalTime)
      }
    }
  }, [user.auth, props.lng])


  function closeCompactViewNotify() {
    Promise.resolve(dispatch(closeAlert)).then(() => {
      redirectMigrated();
      alertLiveScoreNotify();
    })
  }

  function closeNewBetslipMobileNotify() {
    Promise.resolve(dispatch(closeAlert)).then(() => {
        AccountAction.acceptNewMobileBetslip().then(res => {
          if(res) {
            CommonUtil.saveUserData("newBetslipPopupEnabled", false);
            alertLiveScoreNotify();
          }
          else {
            openNewBetslipMobileNotify();
          }
        })
    })
  }

  function openNewBetslipMobileNotify() {
      dispatch(AlertSlice.actions.alert({
          title: props.t("New Bet Slip on Mobile"),
          message: "NEW_MOBILE_BETSLIP_NOTIFY",
          className: "newBetslipNotify",
          okButton: { text: "OK", action: EVENT.CLOSE_NEW_BETSLIP_MOBILE_NOTIFY },
          closeButton: { action: EVENT.CLOSE_NEW_BETSLIP_MOBILE_NOTIFY }
      }))
}

  function alertLiveScoreNotify(){
    const liveScoreNotify = CommonUtil.getPrefByKey("liveScoreNotify") < 0;
    const isRemindLiveScoreLater =  localStorage.getItem('isRemindLiveScoreLater') || false;
    if (liveScoreNotify && !isRemindLiveScoreLater && user.auth && !isChangePasswordPage) {
      dispatch(AlertSlice.actions.alert({
        title: props.t("Enable Live Score Announcements"),
        i18Message: props.t("New feature Live Score Announcement is now available. <br>Do you want to enable this feature for your conveniences?"),
        okButton: { text: "Yes", action: EVENT.ALERT_LIVE_SCORE_NOTIFY_OK },
        cancelButton: { text: "No", action: EVENT.ALERT_LIVE_SCORE_NOTIFY_CANCEL },
        remindButton: { text: "Remind me later", action: EVENT.ALERT_LIVE_SCORE_NOTIFY_REMIND }
      }))
    }
  }

  function redirectMigrated() {
    const isMigrated = localStorage.getItem('urlMigration') || null;
    if(isMigrated) {
      localStorage.removeItem('urlMigration');
      window.location.href = isMigrated;
    }
  }

  function resize() {
    if (ref.current.innerWidth !== window.innerWidth ) {
        ref.current.innerWidth = window.innerWidth;
        if (window.innerWidth <= (1400 + 20)){
          dispatch(LayoutTemplateSlice.actions.updateIsSmallLayout(true));
        } else {
          dispatch(LayoutTemplateSlice.actions.updateIsSmallLayout(false));
        }

    } 
  }

  function checkDataNoCache() {
    try {
      const __udata = CommonUtil.getUserData();
      setAccount()
      if (__udata.auth) {
        let isShowAcceptTC = Boolean(cookie.load('isShowAcceptTC'))
        
        if (__udata.tncEnabled && isShowAcceptTC) {
          if (window.location.pathname.includes('register')) {
            isShowAcceptTC = false;
          }
          if (isShowAcceptTC) {
            setState({
              firstLogin: true,
            })
          }
        }
        else {
          if(CommonUtil.isOpenNewBetslipPopup()) {
            openNewBetslipMobileNotify();
          }
          else {
            alertLiveScoreNotify();
          }
        }
      }

    } catch (e) {
      //log error
    }
  }
  function reloadAccountBalance() {
    const needToChangePW = localStorage.getItem("_needToChangePW");
    if (
      needToChangePW || 
      localStorage.getItem("_needUpdateInfo") ||
      matchPath(get(props.router, 'router.location.pathname', ''), {
        path: "/:lang/change-password",
        exact: true
      }) !== null
    ) { 
      return
    }
    const isCasinoPage = currentPageContainer === 'casinoPageContainer' ||
      currentPageContainer === 'liveCasinoPageContainer';

    AccountAction.accountBalance().then(response => {
      if (response.status === 200) {
        // Hanle for set Self Exclusion
        if (response.data && !response.data.success && user.auth) {
          AccountAction.logout();
          return;
        }
        if (response.error === 'MULTIPLE_LOGIN' ) {
          dispatch(AccountsSlice.actions.resetUser());
          if (isCasinoPage){
            dispatch(AccountsSlice.actions.setRequiredFormData({
              isSessionExpired: true,
            }));
            window.fireEvent(EVENT.REQUIRE_LOGIN);
            return;
          }
          dispatch(AlertSlice.actions.openAlert(
            {
              message: 'errors:' + response.error,
              title: 'default:Error',
              fireEventKey: EVENT.MULTIPLE_LOGIN,
              fireCloseEventKey: EVENT.MULTIPLE_LOGIN
            }
          ))
          return;
        }

        if (response.error) {
          dispatch(AlertSlice.actions.openAlert(
            {
              message: 'errors:' + response.error,
              title: 'default:Error',
            }
          ))
          return
        }
        const loginId = !isNil(response.data.loginId);
        const totalMessage = get(response, 'data.totalMessage', 0);
        loginId && dispatch(AccountsSlice.actions.updateTotalMessage(totalMessage));
        if (!isPA) {
          const totalAnnouncement = get(response, 'data.sumAnnouncement', 0);
          dispatch(AccountsSlice.actions.updateSumAnnouncementUnread(totalAnnouncement));
        }
        //Handle for VIP Account update Tier
        if( !isNil(CommonUtil.getUserData()) ) {
          CommonUtil.saveUserData('currentTierId', response.data.currentTierId);
        }

        dispatch(AccountsSlice.actions.updateUser(
          AccountAction.filterUserData(
            response.data,
            nonLoginCurrency
          )
        ));
        
      }
    });
  }
  function reloadAnnouncementUnread() {
		AccountAction.getSumAnnouncementUnread().then(response => {
			if (response.status === 200) {
				if (response.error) {
					return
				}
				dispatch(AccountsSlice.actions.updateSumAnnouncementUnread(response.data.sumAnnouncementUnread));
			}
		})
      .catch(error => console.error(error));
	}



  function setAccount() {
    reloadAccountBalance();
    isPA && reloadAnnouncementUnread();
  }

  function handleScroll() {
    const isAuthB2B = user.auth ? 'fixed-iframe' : 'fixed-no-auth';
    const _fixed = window.pageYOffset >= Constants.SCROLL_FROM_TOP ? (noneHeader ? isAuthB2B : 'fixed') : '';
    if (ref.current._fixed !== _fixed){
      ref.current._fixed = _fixed;
      dispatch(LayoutTemplateSlice.actions.setFixed({ header: _fixed, body: _fixed }));
    }
  }

  function isShowLiveScoreNotify(){
    if (!user.auth || localStorage.getItem('isRemindLiveScoreLater')){
      return false;
    }
    return true;
  }

  function renderTermsConditions() {
    if (state.firstLogin) {
      return (
        <TermsConditionsComponent locale={user.locale} brandName={user.skin} show={true} enableCompactViewNotify={enableCompactViewNotify}/>
      )
    }
  }

  function getClassName() {
    const classIsLogin = user.auth ? 'auth' : ''
    let className = classIsLogin + ' '
    if (noneHeader) {
      const isB2B = (window.env.isB2B && user.auth) ? '' : ' none-auth'
      className +=  `${isB2B} none-header `
    }
    if (!isEmpty(fixed.header)) {
      className += fixed.header
    }
    if (isHomePage) {
      className += ' landing-header ';
    }
    return className
  }

  const hasHeader = headerComponent.length > 0 
    const renderHeader = headerComponent
  return (
    <React.Fragment>
      <div id="wrapper-header" className={getClassName()}>
        {hasHeader && renderHeader}
      </div>
      <Suspense fallback={null}>
        {renderTermsConditions()}
        {
        isShowLiveScoreNotify() ? 
        <React.Fragment>
          <LiveScoreNotifySettingupComponent/>
          <LiveScoreNotifyContentComponent/>
        </React.Fragment>
        : null
      }
        <WindowPopupComponent/>
      </Suspense>
    </React.Fragment>
  )
}

export default translate()(React.memo(HeaderComponent));


// WEBPACK FOOTER //
// ./src/app/components/HeaderComponent/index.js